<template>
  <nav v-show="isNavBarVisible" id="navbar-main" class="navbar is-fixed-top">
    <div class="navbar-brand">
      <a class="navbar-item is-hidden-desktop" @click.prevent="menuToggleMobile">
        <b-icon :icon="menuToggleMobileIcon"/> <span>Меню</span>
      </a>
      <a class="navbar-item is-hidden-mobile" @click.prevent="menuToggle">
        <b-icon :icon="menuToggleIcon"/>
      </a>
    </div>
    <div class="navbar-brand is-right">
      <div class="navbar-item is-hidden-desktop add-button">
        <router-link :to="{ name: 'order-new' }" class="navbar-item has-background-warning">
            <span>Создать новую заявку</span>
          </router-link>
      </div>
      <a class="navbar-item navbar-item-menu-toggle is-hidden-desktop" @click.prevent="menuNavBarToggle">
        <b-icon :icon="menuNavBarToggleIcon" custom-size="default"/>
      </a>
    </div>
    <div class="navbar-menu fadeIn animated faster" :class="{'is-active':isMenuNavBarActive}">
      <div class="navbar-end">
        <router-link :to="{ name: 'order-new' }" class="navbar-item has-background-warning has-divider add-button">
           <!-- is-desktop-icon-only -->
          <!-- <b-icon icon="cart-plus" custom-size="top-menu" class="has-badge-bottom" /> -->
          <span>Создать заявку</span>
        </router-link>

        <div class="navbar-item has-dropdown has-dropdown-with-icons">
          <a class="navbar-link is-arrowless">
            <div class="is-user-name">
              <span>{{ actor.document.name }}, {{ actor.document.client_name }}</span>
            </div>
          </a>
        </div>
        <a class="navbar-item is-desktop-icon-only" title="Выйти" @click="logout">
          <b-icon icon="logout" custom-size="default"/>
          <span>Выйти</span>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

// @Component({
//   computed: {
//     ...mapState('ubic', [
//       'token',
//     ]),
//     ...mapGetters('ubic', [
//       'isAuthenticated',
//     ]),
//   },
//   methods: {
//     ...mapActions('ubic', [
//       'login', 'logout',
//     ]),
//   },
//   components: {
//     LoginForm,
//     FooterBar,
//     AsideMenu,
//     NavBar
//   }
// })
export default {
  name: 'NavBar',
  components: {
  },
  data () {
    return {
      isMenuNavBarActive: false
    }
  },
  computed: {
    menuNavBarToggleIcon () {
      return (this.isMenuNavBarActive) ? 'close' : 'dots-vertical'
    },
    menuToggleMobileIcon () {
      return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger'
    },
    menuToggleIcon () {
      return this.isAsideExpanded ? 'backburger' : 'forwardburger'
    },
    ...mapState([
      'isNavBarVisible',
      'isAsideMobileExpanded',
      'isAsideExpanded',
      'userName'
    ]),
    ...mapState('ubic', [
      'actor', 'counters'
    ])
  },
  methods: {
    ...mapActions('ubic', [
      'logout',
    ]),
    menuToggleMobile () {
      this.$store.commit('asideMobileStateToggle')
    },
    menuToggle () {
      this.$store.commit('asideStateToggle')
    },
    menuNavBarToggle () {
      this.isMenuNavBarActive = (!this.isMenuNavBarActive)
    },
  }
}
</script>
<style lang="scss" scoped>
.add-button {
  padding: 0;
  font-weight: bold;
  -webkit-box-shadow: 2px 2px 3px 0px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 2px 2px 3px 0px rgba(34, 60, 80, 0.2);
  box-shadow: 2px 2px 3px 0px rgba(34, 60, 80, 0.2);
  a {
    height: 100%;
  }
}
</style>